module.exports = __webpack_public_path__ + "img/icon_progressing.9376b3c2.png";